import type { QueryClient } from "@tanstack/react-query";
import type { BuddyRelationship } from "./relationship";

// Patch only the relationship, retaining the ranked order and every loaded page.
// All three Discover tabs must reflect requests made from a profile on return.
export function updateDiscoveryRelationship(
  client: QueryClient,
  userId: string,
  relationship: BuddyRelationship,
) {
  const patch = (value: unknown): unknown => {
    if (Array.isArray(value)) return value.map(patch);
    if (!value || typeof value !== "object") return value;
    const row = value as Record<string, unknown>;
    if (row.id === userId && "relationship" in row) {
      return { ...row, relationship };
    }
    return Object.fromEntries(
      Object.entries(row).map(([key, child]) => [
        key,
        ["data", "buddies", "people", "pages"].includes(key)
          ? patch(child)
          : child,
      ]),
    );
  };
  const filters = {
    predicate: ({ queryKey }: { queryKey: readonly unknown[] }) =>
      queryKey[0] === "discover" ||
      (queryKey[0] === "hiives" &&
        ["activity-people", "suggested-people"].includes(String(queryKey[1]))),
  };
  // An older list request must not overwrite the new relationship on completion.
  void client.cancelQueries(filters);
  client.setQueriesData(filters, patch);
}
